export default {
    "author": "ffun",
    "siteUrl": "https://blog.ffun.com"
};